import { render, staticRenderFns } from "./TrekTable.vue?vue&type=template&id=0df0884e&scoped=true&"
import script from "./TrekTable.vue?vue&type=script&lang=js&"
export * from "./TrekTable.vue?vue&type=script&lang=js&"
import style0 from "./TrekTable.vue?vue&type=style&index=0&id=0df0884e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df0884e",
  null
  
)

export default component.exports